import moment from 'moment';

import { EditStageForm } from '../domain/stage-update.entity';
import {
	StandardTransactionHistoryListItem,
	StandardTransactionHistoryListItemDto,
} from '../domain/standard-stage.entity';

export const mapTransactionHistoryDto = (
	item: StandardTransactionHistoryListItemDto
): StandardTransactionHistoryListItem => {
	const itemStages = item.stages.filter( (el) => el.code !== '00.00');
	return {
		id: item.id,
		code: itemStages.map(({ code }) => code).join(', '),
		name: itemStages.map(({ name }) => name).join(', '),
		stageCodes: itemStages.map(({ code }) => code),
		createdBy: item.createdBy
		? {
			id: item.createdBy.id,
			name: `${item.createdBy.firstName} ${item.createdBy.lastName}`.trim(),
		}
		: null,
		completeDate: item.completeDate,
		startDate: item.startDate,
		targetDate: item.targetDate,
		eaStageReason: item.eaStageReason,
	}
};

export const mapEditStage = ({ completeDate, startDate, targetDate }: EditStageForm) => ({
	startDate: moment(startDate).format('YYYY-MM-DD'),
	targetDate: targetDate ? moment(targetDate).format('YYYY-MM-DD') : null,
	completeDate: completeDate ? moment(completeDate).format('YYYY-MM-DD') : null,
});
